/* eslint-disable react-hooks/exhaustive-deps */
import './index.scss';
import React, { useEffect, useRef, useState } from 'react';
import { getApp, getBooleanValue } from '../../utils';
import { detail as teacherDetail, statistics as teacherResNum } from '@/services/saas/teacherInfo';
import { info as teacherLiveChannel } from '@/services/saas/liveChannel';
import avatarDefault from '@/images/studio/avatar_default.png';
import { Icon, ListView, NavBar, PullToRefresh } from 'antd-mobile';
import SearchWrapper from '@/components/searchWrapper';
import { Resource } from '@/components/studio/list';
import { ResItem } from '@/components/studio/item';
import { list } from '@/services/saas/res';

export function TeacherItem(props) {
  const { teacherId, sourceApp, onMounted } = props;

  const { appId } = getApp() || {};

  const [detail, setDetail] = useState({});

  const getTeacherData = async () => {
    const respDetail = await teacherDetail({ teacherId });
    const respResNum = await teacherResNum({
      teacherId,
      sceneCode: '2',
      sourceApp: appId,
    });
    const respLiveChannel = await teacherLiveChannel({
      sourceApp: sourceApp || appId,
      sourceModule: 'personal',
      sourceId: teacherId,
    });
    if (respDetail.success && respResNum.success && respLiveChannel.success) {
      setDetail({
        liveChannelStatus: respLiveChannel.data.liveStatus,
        avatar: respDetail.data.avatar,
        name: respDetail.data.userName,
        subject: respDetail.data.teachSubject.split(',').join('、'),
        resNum: respResNum.data.resNum,
        classes: respDetail.data.classes,
      });
    }
  };

  useEffect(() => {
    getTeacherData();
  }, []);

  useEffect(() => {
    if (Object.keys(detail).length > 0 && onMounted) {
      onMounted();
    }
  }, [detail]);

  return (
    <div className="teacherItem">
      <div className={`status ${detail.liveChannelStatus === '1' ? 'ing' : 'will'}`}>
        {detail.liveChannelStatus === '1' ? '正在直播' : '未直播'}
      </div>
      <div className="avatar">
        <img alt="" src={detail.avatar || avatarDefault} />
        {detail.liveChannelStatus === '1' ? <div className="ing"></div> : undefined}
      </div>
      <div className="attr">
        <div className="name">{detail.name || ''}</div>
        <div className="subject-resNum">
          <div className="subject">科目：{detail.subject || '无'}</div>
          <div className="resNum">发布资源：{detail.resNum || 0}</div>
        </div>
        {detail.classes ? (
          <div className="classes">
            {detail.classes.map((item) => (
              <span className="classes-item" key={item.classId}>
                {item.className}
              </span>
            ))}
          </div>
        ) : undefined}
      </div>
    </div>
  );
}

function ListWrap(props) {
  return <div className="teacherRes-list">{props.children}</div>;
}
export default function TeacherDetail(props) {
  const [loading, setLoading] = useState(false);
  const [draging, setDraging] = useState(false);
  let [pageIndex, setIndex] = useState(0);
  const [data, setData] = useState([]);
  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSouce] = useState(dataS);
  const [hasMore, setHasMore] = useState(false);

  const [resType, setResType] = useState(false);
  const [keyValue, setKeyValue] = useState('');
  const { appId } = getApp() || {};
  const {
    match: {
      params: { id },
    },
  } = props;

  const getRes = async (page) => {
    setLoading(true);
    if (page === 1) {
      setData([]);
      setDataSouce(dataSource.cloneWithRows([]));
    }
    const param = {
      current: page || 1,
      size: 6,
      issueFlag: 1,
      sourceApp: appId,
      resType: resType,
      creater: id,
      title: keyValue,
    };
    const resp = await list(param);
    if (resp.success && resp.data) {
      const resourceList = (page === 1 ? [] : data).concat(resp.data.records);
      setDraging(false);
      setLoading(false);
      setData(resourceList);
      setDataSouce(dataSource.cloneWithRows(resourceList));
      setHasMore(resp.data.current < resp.data.pages);
      setIndex(page);
    }
  };

  useEffect(() => {
    if (resType) {
      getRes(1);
    }
  }, [resType, keyValue]);

  const onEndReached = function () {
    if (!loading && hasMore) {
      getRes(++pageIndex);
    }
  };

  const resTypeCodeRef = useRef();

  const listRef = useRef();

  const row = (rowData, sectionID, rowID) => {
    const {
      resId,
      title,
      coverUrl,
      deptName,
      createrName,
      resAttributeDetailList,
      viewNum,
    } = rowData;

    const resAttr =
    resAttributeDetailList.length > 0
    ? resAttributeDetailList[0].attributeValueName +
    resAttributeDetailList[2].attributeValueName
    : null;

    return (
      <div className="teacherRes-list-item" key={rowID}>
        <ResItem
          id={resId}
          name={title}
          cover={coverUrl}
          dept={deptName}
          teacher={createrName}
          resAttr={resAttr}
          viewNum={viewNum}
          showViewNum={resTypeCodeRef.current === 'VIDEO'}
        />
      </div>
    );
  };

  return (
    <div className={`teacherDetail${getBooleanValue('IS_IMMERSE', false) ? ' immerse' : ''}`}>
      <NavBar mode="light" icon={<Icon type="left" />} onLeftClick={() => window.history.go(-1)}>
        <span>任课老师详情</span>
      </NavBar>
      <div className="content">
        <SearchWrapper className="searchDuery" hideSelector onChange={setKeyValue}></SearchWrapper>
        <div className="detail">
          <TeacherItem
            className="detail"
            teacherId={id}
            sourceApp={appId}
            onMounted={() => {
              const listDom = listRef.current
                ? listRef.current.listviewRef.ListViewRef.ScrollViewRef
                : false;
              if (listDom) {
                listDom.style.height =
                  Math.floor(document.body.clientHeight - listDom.getClientRects()[0].top) + 'px';
              }
            }}
          />
        </div>
        <Resource
          className="teacherRes-resModel"
          sourceApp={appId}
          onChange={(type, typeCode) => {
            setResType(type);
            resTypeCodeRef.current = typeCode;
          }}
        />
        <ListView
          ref={listRef}
          dataSource={dataSource}
          renderHeader={false}
          renderFooter={() => (
            <div style={{ padding: 10, textAlign: 'center' }}>
              {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
            </div>
          )}
          renderBodyComponent={() => <ListWrap />}
          renderRow={row}
          className="teacherRes-list-wrap"
          pageSize={4}
          onScroll={() => {
            console.log('scroll');
          }}
          scrollRenderAheadDistance={500}
          onEndReached={onEndReached}
          onEndReachedThreshold={10}
          pullToRefresh={
            <PullToRefresh
              refreshing={draging}
              onRefresh={() => {
                setDraging(true);
                getRes(1);
              }}
            />
          }
        />
      </div>
    </div>
  );
}
